export default "<ngx-ui-loader></ngx-ui-loader>\r\n<toaster-container [toasterconfig]=\"config\"></toaster-container>\r\n<router-outlet></router-outlet>\r\n"